module.exports = __webpack_public_path__ + "img/noimage.8872b163.png";